import { useContext } from 'react';
import { ComponentsContext } from './components-context-provider';

type ContextType = {
  RTL: boolean,
  theme: any,
  disableAnimation: boolean,
  [key: string]: any;
};
type GetContextTypeFn = (fn: ContextType) => any;

export default (fn: GetContextTypeFn) => {
  const {
    RTL = false,
    theme,
    disableAnimation = false,
  }: ContextType = useContext(ComponentsContext);

  return fn({ RTL, theme, disableAnimation });
};
